<div class="grid-row grid-row--aic" data-cy="multi-invoice-card">
  <div class="grid-col grid-col--auto grid-col--sm-order-0">
    <a *ngIf="invoiceTableDataObject.getType() === PayableType.PREPAYMENT; else invoiceDownload"
      [routerLink]="['/', ROUTE_TOKEN_MAIN_BASE, ROUTE_TOKEN_ENGAGEMENTS_BASE, invoiceTableDataObject.getResourceId()]"
      class="review-invoices__figure"
      data-cy="preview-pdf"
    >
      <img [src]="assetUriService.customerAssetUrl + 'stock-nextgen-pdf.svg'" height="120" class="review-invoice__image">
    </a>
    <ng-template #invoiceDownload>
      <div [ngStyle]="{'pointer-events' : invoiceTableDataObject.invoice.invoiceFileId == null ? 'none' : 'inherit'}"
        (click)="invoicePdfService.previewInvoiceAsPDF(invoiceTableDataObject.invoice.arTran.id)"
        class="review-invoices__figure"
        data-cy="preview-pdf"
      >
        <img [src]="assetUriService.customerAssetUrl + 'stock-nextgen-pdf.svg'" height="120" class="review-invoice__image">
      </div>
    </ng-template>
  </div>

  <div class="grid-col grid-col--sm-12">
    <div class="review-invoices__cont">
      <h4 class="removed--sm">{{invoiceTableDataObject.getReviewTitle()}}</h4>

      <div class="mt--050 grid-row grid-row--jcb">
        <div class="grid-col grid-col--auto">Company</div>
        <div class="grid-col fw--300 ta--right tc--darkest">{{configService.customerName}}</div>
      </div>

<!--      <div class="mt&#45;&#45;050 grid-row grid-row&#45;&#45;jcb">-->
<!--        <div class="grid-col grid-col&#45;&#45;auto">Description</div>-->
<!--        <div class="grid-col fw&#45;&#45;300 ta&#45;&#45;right tc&#45;&#45;darkest">{{invoiceTableDataObject.invoice.description}}</div>-->
<!--      </div>-->

      <div class="mt--050 grid-row grid-row--jcb">
        <div class="grid-col grid-col--auto">Status</div>
        <div class="grid-col ta--right">
          <div *ngIf="invoiceTableDataObject?.overdue || invoiceTableDataObject.displayStatus === DUE_UPON_RECEIPT; then thenBlock else elseBlock"></div>
          <ng-template #thenBlock>
            <span [ngClass]="!configService.dueUponReceipt ? 'tc--error' : 'tc--xxdark'">{{ invoiceTableDataObject.displayStatus !== DUE_UPON_RECEIPT ? "Overdue" : "" }} {{ invoiceTableDataObject.displayStatus }}</span>
          </ng-template>
          <ng-template #elseBlock><span class="tc--warning">Due {{invoiceTableDataObject.displayStatus}}</span></ng-template>
        </div>
      </div>

      <div class="mt--050 grid-row grid-row--jcb">
        <div class="grid-col grid-col--auto">Previous Payments</div>
        <div class="grid-col fw--300 ta--right tc--darkest">
          {{ invoiceTableDataObject.invoice.arTran.allocated | currency : invoiceTableDataObject.currency?.code }}
        </div>
      </div>
    </div>
  </div>

  <div class="grid-col grid-col--auto removed--sm">
    <div class="review-invoices__vr"></div>
  </div>

  <div class="grid-col grid-col--auto grid-col--sm grid-col--sm-order-0">
    <div class="review-invoices__foot">
      <h4 class="mb--050 removed blocked--sm">Invoice {{invoiceTableDataObject.invoice.invoiceNumber}}</h4>
      <div [hidden]="!payPartialActive && invoiceTableDataObject.canPayPartially()">
        <input
          #payPartialInput
          [ngModel]="amountToPay"
          (ngModelChange)="amountToPay = $event"
          (keyup)="updateAmountForPartialPayment(invoiceTableDataObject)"
          (keyup.enter)="updateAmountForPartialPayment(invoiceTableDataObject)"
          (focusout)=updateAmountForPartialPayment(invoiceTableDataObject)
          [ngClass]="valid ? 'form-valid' : 'form-input--invalid' "
          class="form-input review-invoices__input"
          numberOnly
          exceptions="."
          [maxDecimalPlaces]="2"
          min="0.01"
          data-cy="partial-payment-amount">
        <!--         Total: {{invoiceTableDataObject.invoiceAmount - invoiceTableDataObject.previousAmountPaid | number: '1.2-2'}} -->
      </div>
      <div *ngIf="!payPartialActive && invoiceTableDataObject.canPayPartially()" class="h3 review-invoices__amount">
        {{ amountToPay | currency : invoiceTableDataObject.currency?.code }}
      </div>
      <div class="mt--050 p">&nbsp;</div>
      <div class="mt--050 p removed--sm">&nbsp;</div>
      <div class="mt--050 p p--sm">
        <div *ngIf="configService.partialPaymentsEnabled">
          <div *ngIf="!payPartialActive && invoiceTableDataObject.canPayPartially()">
            <button (click)="activatePayPartial()" type="button" class="inline-link" data-cy="activate-partial-pay">Pay Partially</button>
          </div>
        </div>
        <div *ngIf="payPartialActive && invoiceTableDataObject.canPayPartially()" class="tc--error">
          <button (click)="deactivatePayPartial(invoiceTableDataObject)" type="button" class="inline-link" data-cy="deactivate-partial-pay">Pay Full Amount</button>
        </div>
      </div>
      <div class="mt--050 p p--sm">
        <button
          type="button"
          class="inline-link"
          (click)="onRemovePayable(invoiceTableDataObject.arTranId)"
          data-cy="remove-invoice"
        >
          Remove
        </button>
      </div>
    </div>
  </div>
</div>
